import { render, staticRenderFns } from "./MCCourse.vue?vue&type=template&id=4dfd3116&scoped=true"
import script from "./MCCourse.vue?vue&type=script&lang=js"
export * from "./MCCourse.vue?vue&type=script&lang=js"
import style0 from "./MCCourse.vue?vue&type=style&index=0&id=4dfd3116&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4dfd3116",
  null
  
)

export default component.exports